function CartBirthstoneHandler() {
  this.birthstoneVariantId = '45356435275947';
  this.debounceTimer = null;
  this.debounceDelay = 800;
  this.isProcessing = false;
  this.init();
}

CartBirthstoneHandler.prototype.init = function() {
  this.observeCartChanges();
  this.observeAddToCartGlobally();
};

CartBirthstoneHandler.prototype.observeCartChanges = function() {
  var self = this;
  
  document.addEventListener('change', function(event) {
    if (event.target.name && event.target.name.includes('updates[')) {
      console.log('Birthstone: Quantity change detected');
      self.debouncedCheckCartItems();
    }
  });
  
  document.addEventListener('click', function(event) {
    var target = event.target;
    var removeButton = target.closest('.cart-items__remove, [data-cart-remove], .remove-item');
    
    if (removeButton) {
      console.log('Birthstone: Remove button clicked');
      self.debouncedCheckCartItems();
    }
  });
  
  document.addEventListener('click', function(event) {
    var target = event.target;
    var quantityButton = target.closest('.quantity-selector button, .qty-btn, [data-quantity-change]');
    
    if (quantityButton) {
      console.log('Birthstone: Quantity button clicked');
      self.debouncedCheckCartItems();
    }
  });
};

CartBirthstoneHandler.prototype.observeAddToCartGlobally = function() {
  var self = this;
  
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      self.debouncedCheckCartItems();
    }
  });
  
  var originalFetch = window.fetch;
  if (!window.birthstoneFetchWrapped) {
    window.fetch = function(url, options) {
      if (url && (url.includes('/cart/add') || url.includes('/cart/change'))) {
        self.debouncedCheckCartItems();
      }
      return originalFetch.apply(this, arguments);
    };
    window.birthstoneFetchWrapped = true;
  }
  
  document.addEventListener('cart:updated', function() {
    self.debouncedCheckCartItems();
  });
  
  document.addEventListener('cart:refresh', function() {
    self.debouncedCheckCartItems();
  });
  
  document.addEventListener('cart:changed', function() {
    self.debouncedCheckCartItems();
  });
  
  document.addEventListener('click', function(event) {
    var target = event.target;
    var button = target.closest('[name="add"], .btn-cart, .add-to-cart, .product-form__cart-submit, [data-add-to-cart]');
    
    if (button) {
      self.debouncedCheckCartItems();
    }
  });
};

CartBirthstoneHandler.prototype.debouncedCheckCartItems = function() {
  var self = this;
  
  if (this.isProcessing) {
    console.log('Birthstone: Already processing, ignoring action');
    return;
  }
  
  console.log('Birthstone: Starting cart check process');
  
  if (this.debounceTimer) {
    clearTimeout(this.debounceTimer);
  }
  
  this.disableCartForm();
  
  this.debounceTimer = setTimeout(function() {
    console.log('Birthstone: Debounce completed, checking cart');
    self.checkCartItems();
  }, this.debounceDelay);
};

CartBirthstoneHandler.prototype.disableCartForm = function() {
  this.isProcessing = true;
  var cartForm = document.getElementById('cart-form');
  if (cartForm) {
    console.log('Birthstone: Disabling cart form');
    cartForm.style.opacity = '0.5';
    cartForm.style.pointerEvents = 'none';
    cartForm.style.transition = 'opacity 0.3s ease';
  } else {
    console.log('Birthstone: Cart form not found');
  }
};

CartBirthstoneHandler.prototype.checkCartItems = function() {
  var self = this;
  this.getCart().then(function(cart) {
    self.processCartItems(cart.items);
  });
};

CartBirthstoneHandler.prototype.processCartItems = function(items) {
  console.log('Birthstone: Processing cart items, total items:', items.length);
  
  var totalBirthstoneNeeded = 0;
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    
    if (item.properties) {
      var birthstoneProperty = item.properties['Birthstone (+₹45)'];
      
      if (birthstoneProperty && birthstoneProperty !== 'no') {
        console.log('Birthstone: Found birthstone property:', birthstoneProperty, 'quantity:', item.quantity);
        totalBirthstoneNeeded += item.quantity;
      }
    }
  }
  
  var currentBirthstoneQuantity = 0;
  var birthstoneItems = [];
  
  for (var j = 0; j < items.length; j++) {
    var cartItem = items[j];
    if (cartItem.id.toString() === this.birthstoneVariantId) {
      console.log('Birthstone: Found existing birthstone item, quantity:', cartItem.quantity);
      currentBirthstoneQuantity += cartItem.quantity;
      birthstoneItems.push(cartItem);
    }
  }
  
  console.log('Birthstone: Total birthstone needed:', totalBirthstoneNeeded);
  console.log('Birthstone: Current birthstone quantity:', currentBirthstoneQuantity);
  
  if (totalBirthstoneNeeded !== currentBirthstoneQuantity) {
    if (totalBirthstoneNeeded === 0) {
      console.log('Birthstone: Removing all birthstone');
      this.removeAllBirthstone(birthstoneItems);
    } else if (currentBirthstoneQuantity === 0) {
      console.log('Birthstone: Adding birthstone product');
      this.addBirthstoneProduct(totalBirthstoneNeeded);
    } else {
      console.log('Birthstone: Updating birthstone quantity');
      this.updateBirthstoneToExactQuantity(totalBirthstoneNeeded, birthstoneItems);
    }
  } else {
    console.log('Birthstone: Sync complete - no changes needed');
    this.isProcessing = false;
  }
};

CartBirthstoneHandler.prototype.addBirthstoneProduct = function(quantity) {
  console.log('Birthstone: Adding birthstone product with quantity:', quantity);
  
  var formData = {
    'items': [{
      'id': this.birthstoneVariantId,
      'quantity': quantity,
      'properties': {
        '_birthstone_addon': 'true',
        '_readonly': 'true'
      }
    }]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  }).then(function(response) {
    console.log('Birthstone: Add to cart response status:', response.status);
    return response.json().then(function(data) {
      console.log('Birthstone: Add to cart response data:', data);
      if (response.ok) {
        console.log('Birthstone: Reloading page in 800ms');
        setTimeout(function() {
          window.location.reload();
        }, 800);
      }
    });
  }).catch(function(error) {
    console.error('Birthstone: Error adding birthstone:', error);
  });
};

CartBirthstoneHandler.prototype.updateBirthstoneToExactQuantity = function(targetQuantity, birthstoneItems) {
  if (birthstoneItems.length > 0) {
    this.updateCartItemQuantity(birthstoneItems[0].key, targetQuantity);
    
    for (var i = 1; i < birthstoneItems.length; i++) {
      this.updateCartItemQuantity(birthstoneItems[i].key, 0);
    }
    
    setTimeout(function() {
      window.location.reload();
    }, 800);
  }
};

CartBirthstoneHandler.prototype.removeAllBirthstone = function(birthstoneItems) {
  for (var i = 0; i < birthstoneItems.length; i++) {
    this.updateCartItemQuantity(birthstoneItems[i].key, 0);
  }
  
  setTimeout(function() {
    window.location.reload();
  }, 800);
};

CartBirthstoneHandler.prototype.updateCartItemQuantity = function(key, quantity) {
  var updateData = {
    'id': key,
    'quantity': quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updateData)
  });
};

CartBirthstoneHandler.prototype.getCart = function() {
  return fetch('/cart.js')
    .then(function(response) {
      return response.json();
    })
    .catch(function() {
      return { items: [] };
    });
};

document.addEventListener('DOMContentLoaded', function() {
  new CartBirthstoneHandler();
});